import { defineMessages } from 'react-intl';

const messages = defineMessages({
  playerErrorTitle: {
    id: 'player.error.title',
    defaultMessage: 'Playback Error',
  },
  playerErrorCTA: {
    id: 'player.error.cta',
    defaultMessage: 'Go back',
  },
  playerStartNowCTA: {
    id: 'player.startNow.cta',
    defaultMessage: 'Start Now',
  },
});

export default messages;
